<div
  [ngClass]="
    [
      'collapsible-sheet-aside',
      '[ fixed tablet-l:sticky ]',
      '[ surface ]',
      '[ max-w-11/12 inset-b-0 inset-is-0 tablet-l:inset-is-auto  ]',
      '[ p-m tablet-l:p-0 ]',
      '[ border-ie corner-right-l tablet-l:corner-none ]',
      '[ transform ]',
      '[ elevation-5 no-elevation-layer  tablet-l:elevation-0  ]',
      '[ index-slideout tablet-l:index-content-on-surface ]',
      '[ transition-transform ]'
    ].concat(expanded ? ['translate-x-0'] : ['-translate-x-extreme', 'tablet-l:translate-x-0'])
  "
  #aside
  (swipeleft)="updateExpanded(false)"
>
  <button
    inline-icon-button
    class="[ absolute right-0 top-0 ] [ tablet-l:hidden ] collapsible-sheet__aside-close"
    (click)="updateExpanded(false)"
    icon="close"
  >
  </button>

  <div class="[ overflow-auto h-full ]">
    <ng-content select="[aside]"></ng-content>
  </div>
</div>

<div
  class="[ fixed inset-0 scrim bg-opacity-low ] [ index-scrim ] [ backdrop-filter backdrop-blur-s ]"
  [ngClass]="expanded ? 'block tablet-l:hidden' : 'hidden'"
  (click)="updateExpanded(false)"
></div>

<div
  data-cy="resizer"
  [ngClass]="[
    'collapsible-sheet-resizer',
    '[ sticky top-0 bottom-0 hidden tablet-l:block ]',
    '[ transparent  ]',
    '[ cursor-col-resize ]',
    '[ index-fab group ]'
  ]"
  (mousedown)="onResizeMouseDown()"
>
  <div
    data-cy="resize-handle"
    class="resize-handle [ imposter overflow-visible ] [ surface-variant group-hover:secondary ] [ border corner-xs ] [ transition-colors ]"
  ></div>
</div>
<div class="[ collapsible-sheet-main ] [ relative ] [ index-surface ]">
  <ng-content select="[main]"></ng-content>
</div>
